import React from 'react';
import { LuxuryHomesCheckout } from '@components';
import './style.scss';

export const LuxuryHomesCheckoutPage: React.FC = () => {
  return (
    <div className="luxury-homes-checkout-page">
      <LuxuryHomesCheckout />
    </div>
  );
}; 